import React from "react";

export default function ContactInfoControlSelector({ control,
                                                     isContactInfoRequiredByRadioGroupOptions,
                                                     contactInfo,
                                                     setContactInfo }) {
    return (
        <div className="contact-info-control__selector" style={{display: (control.IsRequired || isContactInfoRequiredByRadioGroupOptions) ? "none" : ""}}>
            <div
                className={contactInfo.isIncluded
                    ? "contact-info-control__selector__item_active"
                    : "contact-info-control__selector__item"}
                onClick={() => setContactInfo({ ...contactInfo, isIncluded: true })}>Yes</div>
            <div
                className={!contactInfo.isIncluded
                    ? "contact-info-control__selector__item_active"
                    : "contact-info-control__selector__item"}
                onClick={() => (!isContactInfoRequiredByRadioGroupOptions && !control.IsRequired) && setContactInfo({ ...contactInfo, isIncluded: false })}>No</div>
        </div>
    )
}